module.exports = __webpack_public_path__ + "media/images/athletes/1402-674d355bacbf01777550b1a815a453e8.png";